const buildVersion = "1.0.1";

export default buildVersion;
